var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"surf-content-empty-section"},[_c('div',{staticClass:"surf-content-empty-section-content"},[_c('SvgIcons',{staticClass:"surf-content-empty-section-icon",attrs:{"name":"surf_icon_empty"}}),_c('span',{staticClass:"surf-content-empty-section-text"},[_vm._v(_vm._s(_vm.emptyText))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }